var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrCode = function SvgQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.616.999H2.848a1.845 1.845 0 0 0-1.846 1.848v2.772M20.387.999h2.768a1.845 1.845 0 0 1 1.846 1.848v2.772M5.616 25H2.848a1.845 1.845 0 0 1-1.846-1.847v-2.772m19.385 4.62h2.768a1.845 1.845 0 0 0 1.846-1.848v-2.772M5.607 17.647v2.772h2.769m4.62 0v-2.771h-2.768m10.149-9.276h-2.769V5.601m2.769 9.248v-2.772h-2.769m0 5.57v2.772h2.769M11.144 5.601H7.453a1.845 1.845 0 0 0-1.846 1.847v3.696a1.85 1.85 0 0 0 1.846 1.848h3.691a1.845 1.845 0 0 0 1.846-1.848V7.448a1.849 1.849 0 0 0-1.846-1.847Z",
    stroke: "#EDEDF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgQrCode;